企业的api目录

```js
import request, { storeRequest } from '@/libs/request';
export const getDataCenterInfoApi = (data) => request('getDataCenterInfo', data);
export const getProductListApi = (data) =>
  storeRequest({ cmd: 'GetProductList', payload: data }, { key: 'GetProductList', cache: true });
```